var HomePageTypes = {
    CS: 1,
    EXTRA: 2,
    BOTH: 3
};
export default HomePageTypes;
